import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { Order } from '../Order'

export interface ISetCustomShippingCarrier extends IAction<Order, SetCustomShippingCarrierArgs> {}

@InputType()
export class SetCustomShippingCarrierArgs extends ActionArgs {
  @Field(() => ID)
  orderId: string

  @Field(() => String)
  carrier: string

  @Field(() => String)
  serviceCode: string
}
